import { useAppDispatch } from '@/shared/hooks/useStore';
import { registerNewVersionListener } from '@/shared/utils/newVersionNotifier';
import { updateDetected } from '@/viewmodel/shared/versionCheck/state/versionCheckSlice';
import { useEffect } from 'react';

export function useNewVersionListener(): void {
  const dispatch = useAppDispatch();

  useEffect(() => registerNewVersionListener(() => dispatch(updateDetected(null))), [dispatch]);
}
